<script>
	import { browser } from "$app/environment";
</script>

{#if browser}
<div class="accepted-cards flex">
    <img src={`/images/mastercard.svg`} alt="Mastercard" />
    <img src={`/images/visa.svg`} alt="Visa" />
    <img src={'/images/apple-pay-mark.svg'} alt="Apple Pay" />
    <img src={'/images/google-pay-mark.png'} alt="Google Pay" />
</div>
{/if}


<style lang="scss">
    .accepted-cards {
		justify-content: space-evenly;
		flex-direction: row;
        max-height: 50px;
		img {
			max-width: 80px;
            // max-height: 100px;
			padding: 7px;
		}
	}
</style>